import { createContext } from 'react'

import type { UseTabsProviderReturn } from './use-tabs'

export type TabsContext = Partial<UseTabsProviderReturn>

export const TabsContext = createContext<TabsContext>({})
